import gql from 'graphql-tag';

export const CCA_START_GENERATE_CREATIVES_MUTATION = gql`
  mutation CcaStartGenerateCreativesMutation(
    $articleIds: [ID!]!
    $perArticleOverrides: [TriggerCcaPerArticleOverrideInput!]
    $resolvedInputs: [TriggerCcaResolvedInputInput!]
    $runSettingsOverrides: TriggerCcaRunSettingsOverrideInput
  ) {
    ccaStartGenerateCreatives(
      articleIds: $articleIds
      perArticleOverrides: $perArticleOverrides
      resolvedInputs: $resolvedInputs
      runSettingsOverrides: $runSettingsOverrides
    ) {
      jobId
    }
  }
`;
